import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class CommonStructureService {
    public selectPath: string;
    public selectType: string;
    public sessionId: string;
    private server_ip: string;

    private commonstructure_url = '/api/dev/main/v1.0/commonstructure';


    constructor(private http: HttpClient, @Inject('url') private url: string) {
        this.server_ip = (url === null || url === undefined) ? 'http://10.24.19.140:5000' : url;
        this.sessionId = gsp.cache.get('sessionId');
    }

    /**
     * æ ¹æ®åæ°æ®ç±»ååidï¼è·åéç¨structure
     * @param type åæ°æ®ç±»å
     * @param id åæ°æ®id
     */
    getCommonStructure(type:string,id:string):Observable<any>{
        const headers = new HttpHeaders().set('SessionId', this.sessionId);
        const url = this.server_ip + this.commonstructure_url + '?type=' + type + '&id=' + id;
        return this.http.get(url, { headers });
    }


}